

<div class="heroBanner bgPrimary">
    <div class="container">
        <h1 class="colorWhite text-center"></h1>
    </div>
    
</div>

<div class="bgWhite py-80">
    <div class="container">
        <div class="embed-responsive embed-responsive-16by9">
            <iframe [src]="securityByPass('https://www.youtube.com/embed/'+youtubeID)" 
            allowfullscreen width="500px"></iframe>
          </div>
    </div>
</div>